'use client'
import { isCoinbaseWaasEnabled } from '../../functions/isCoinbaseWaasEnabled/isCoinbaseWaasEnabled.js';

const validateMPCProviderEnabled = (projectSettings) => {
    if (!projectSettings) {
        throw new Error('Project settings are missing');
    }
    const isCoinbaseWaaSProviderEnabled = isCoinbaseWaasEnabled(projectSettings);
    if (!isCoinbaseWaaSProviderEnabled) {
        throw new Error('No embedded wallet is enabled. Go to the dashboard and make sure to have both Embedded wallets and at least one EVM network enabled. Also, check if EthereumWalletConnectors is in the DynamicContextProvider > settings > walletConnectors.');
    }
};

export { validateMPCProviderEnabled };
